import { RadioSelect } from '@uc/web/shared/data-models';
import {
	CourseSearchFilterPill,
	CourseSearchFilterType,
} from '../models/course-search-filter.models';
import { ProductEnum } from '@uc/shared/data-models';

export const generatePill = (
	link: string | undefined,
	options: RadioSelect[],
	filterType: CourseSearchFilterType,
): CourseSearchFilterPill | undefined => {
	if (!link) return;

	const selectedOption = options.find((option) => link === option.link);

	if (!selectedOption) return;

	const removeActionDisabled = [
		ProductEnum.Undergraduate,
		ProductEnum.Postgraduate,
		ProductEnum.Clearing,
	].includes(link as any);

	return {
		label: selectedOption.name,
		value: selectedOption.link,
		filterType,
		removeActionDisabled,
	};
};

export const generateUcasPointsPill = (
	points: (number | undefined)[],
): CourseSearchFilterPill | undefined => {
	if (!points.every((point) => point)) return;

	return {
		label: `${points.join('-')} UCAS Tariff Points`,
		value: `ucaspts${points.join('_')}`,
		filterType: 'UCAS_POINTS',
		removeActionDisabled: false,
	};
};
